import currency from 'currency.js';
import Swiper from 'swiper/bundle';
import solver from 'solver-utilities';
import { cart, add, get, open } from './cart.js';
import { info, success, error } from './notification.js';
import { TYPES } from './types.js';
import { shopify } from './shopify.js';
import { history, handleize, sanitizeProductOptions } from './helpers.js';
import { validation } from './validation.js';

let personlizationTimeout = null;
let swatchOptions = [
  'Canvas/Cordura Color',
  'canvas/cordura color',
  'Color',
  'color',
  'Colors',
  'leather',
  'Leather',
  'Leathers',
  'leathers',
  'Mens Boots Width',
  'Other',
  'other',
  'Womans Boots Width'
];

const state = {
  options: {},
  variant: null,
  swiper: null,
  recipients: [
    {
      id: 1,
      email: '',
      message: ''
    }
  ],
  properties: {
    Initials: '',
    Style: 'style1'
  },
  set setOption(obj) {
    if (!obj.key || !obj.value) return;
    this.options[obj.key] = obj.value;

    if (!window.Solver.product) return;

    const variants = [...window.Solver.product.variants];
    variants.forEach((variant) => {
      let limit = variant.options.length;
      let hits = 0;

      for (let option in this.options) {
        let _option = this.options[option];
        let option1 = '';
        let option2 = '';
        let option3 = '';

        if (variant.option1) {
          if (variant && variant.option1.indexOf('"') > -1) {
            option1 = handleize(variant.option1);
          } else {
            option1 = variant.option1;
          }
        }

        if (variant.option2) {
          if (variant && variant.option2.indexOf('"') > -1) {
            option2 = handleize(variant.option2);
          } else {
            option2 = variant.option2;
          }
        }

        if (variant.option3) {
          if (variant && variant.option3.indexOf('"') > -1) {
            option3 = handleize(variant.option3);
          } else {
            option3 = variant.option3;
          }
        }

        if (_option === option1) hits++;
        if (_option === option2) hits++;
        if (_option === option3) hits++;
      }

      if (hits === limit) {
        this.setVariant = variant;
      }
    });
  },
  set setVariant(variant) {
    this.variant = variant;

    //Update SKU in Product Details
    const sku = document.querySelector('[data-product-sku]');
    if (sku && state && state.variant && state.variant.sku)
      sku.innerHTML = `Product #: ${state.variant.sku}`;
  },
  set setSwiper(swiper) {
    this.swiper = swiper;
  },
  set setProperties(properity) {
    if (!properity) return;

    const keys = Object.keys(properity);

    if (!keys || (keys && !keys.length)) return;

    this.properties = { ...properity };
  },
  set setRecipients(recipients) {
    if (!recipients) return;

    this.recipients = recipients;
  },
  set addRecipient(recipient) {
    const recipients = this.recipients;

    recipients.push(recipient);

    this.recipients = recipients;
  }
};

const setPersonalizationUI = async function () {
  const product = window.Solver.product;
  const src = {};

  if (!product) return;

  const media = [...product.media].filter((item) => item.alt == TYPES.MEDIA.PERSONALIZE.ALT);

  media.forEach((item) => {
    const slides = document.querySelectorAll(`[data-personalize="${item.id}"]`);
    if (!slides || (slides && !slides.length)) return;

    slides.forEach((slide) => {
      const existing_canvas = slide.querySelector('canvas');
      if (existing_canvas) return;

      let variantId = slide.getAttribute('data-variant');
      if (!variantId) {
        const params = solver.frontend.queryParams('variant');
        if (params) variantId = params;
      }

      const { properties } = window.Solver;
      const property = properties[variantId];
      const canvas = document.createElement('canvas');
      canvas.setAttribute('data-el', 'product-properties');
      canvas.setAttribute('data-property-src', item.src);
      canvas.setAttribute('data-variant', variantId);

      if (property) {
        canvas.setAttribute('data-shadow', property.shadow_color);
        canvas.setAttribute('data-shadow-opacity', property.shadow_opacity);
        canvas.setAttribute('data-highlight', property.highlight_color);
        canvas.setAttribute('data-highlight-opacity', property.highlight_opacity);
      }

      canvas.width = 2000;
      canvas.height = 2000;
      slide.prepend(canvas);
    });
  });

  await solver.each.asyncTimeout(250);

  setPersonalizationProperties(null, state.properties.Style);
};

/*
 * Sets variant properties per line item
 * @param { object } event - user driven event
 * @param { string } key - name of property to set
 * @param { string } value - value of property
 */
const setPersonalizationProperties = function (event, key) {
  if (event) event.preventDefault();
  if (!key) return;

  const properties = {
    Style: state.properties.Style,
    Initials: state.properties.Initials
  };

  if (key == 'style1' || key == 'style2') {
    const styles = document.querySelectorAll('[data-style]');
    styles.forEach((style) => style.classList.remove('style--active'));

    properties.Style = key;
  }

  if (key == 'Initials') {
    const target = event.currentTarget;
    let value = target.value.toUpperCase();

    if (!validation.alphachar(value)) {
      let valueArr = [];
      value.split('').forEach((v) => {
        if (validation.alphachar(v)) valueArr.push(v);
      });

      value = valueArr.join('');
      target.value = value;
    }

    properties.Initials = value;
  }

  const styleBtn = document.querySelector(`[data-style="${properties.Style}"]`);
  if (styleBtn) styleBtn.classList.add('style--active');
  state.setProperties = properties;

  const canvases = document.querySelectorAll('[data-el="product-properties"]');
  if (!canvases || (canvases && !canvases.length)) return;

  if (!properties.Initials || (properties.Initials && properties.Initials == '')) {
    canvases.forEach((canvas) => canvas.classList.add('hidden'));
    return;
  }

  canvases.forEach((canvas) => {
    const value = state.properties.Initials;
    let shadowColor = canvas.getAttribute('data-shadow');
    let shadowOpacity = canvas.getAttribute('data-shadow-opacity');
    let highlightColor = canvas.getAttribute('data-highlight');
    let highlightOpacity = canvas.getAttribute('data-highlight-opacity');
    const src = canvas.getAttribute('data-property-src');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    const { width, height } = canvas;

    ctx.clearRect(0, 0, width, height);

    if (!shadowColor) shadowColor = '#000000';
    if (!shadowOpacity) shadowColor = 1;
    if (!highlightColor) shadowColor = '#000000';
    if (!highlightOpacity) shadowColor = 1;

    if (!src) return;

    canvas.classList.remove('hidden');

    const diff = ctx.measureText(value).width / width;
    const x = ((parseFloat(window.Solver.properties.canvas.x) + diff) / 100) * width;
    const y = (parseFloat(window.Solver.properties.canvas.y) / 100) * height;

    const hexToRgba = function (hex, opacity) {
      if (!hex) return 'rgba(0,0,0,0)';

      let value = hex.replace('#', '');
      let o = parseInt(opacity);

      var bigint = parseInt(value, 16);
      var r = (bigint >> 16) & 255;
      var g = (bigint >> 8) & 255;
      var b = bigint & 255;
      let a = `0.${o}`;

      if (o >= 10) a = '1.0';

      return `rgba(${r}, ${g}, ${b}, ${a})`;
    };

    img.src = src;
    ctx.drawImage(img, 0, 0, width, height);
    const fontSize = window.Solver.properties.canvas.size;
    const x2 = x + 10 + diff / 2;
    const y2 = y + (diff * 100) / 3;

    const font = `${fontSize / 1.1}px "leathercrafter"`;
    const highlightStyle = hexToRgba(highlightColor, highlightOpacity);
    const lineWidth = 3;
    const shadowStyle = hexToRgba(shadowColor, shadowOpacity);
    const textAlign = 'center';
    const textBaseline = 'middle';
    const offset = 5;

    if (value && value.length >= 3 && state.properties.Style == 'style2') {
      // shadow
      ctx.font = `${fontSize / 1.4}px "leathercrafter"`;
      ctx.strokeStyle = shadowStyle;
      ctx.textAlign = textAlign;
      ctx.textBaseline = textBaseline;
      ctx.lineWidth = lineWidth;
      ctx.strokeText(value[0] + '          ' + value[2], x, y);

      ctx.font = `${fontSize * 1.4}px "leathercrafter"`;
      ctx.strokeStyle = shadowStyle;
      ctx.textAlign = textAlign;
      ctx.textBaseline = textBaseline;
      ctx.lineWidth = lineWidth;
      ctx.strokeText(value[1], x2, y2);

      // hightlights
      ctx.font = `${fontSize / 1.4}px "leathercrafter"`;
      ctx.strokeStyle = highlightStyle;
      ctx.strokeText(value[0] + '          ' + value[2], x + 5, y);

      ctx.font = `${fontSize * 1.4}px "leathercrafter"`;
      ctx.strokeStyle = highlightStyle;
      ctx.strokeText(value[1], x2 + offset, y2);
    } else {
      ctx.font = font;
      // shadow
      ctx.strokeStyle = shadowStyle;
      ctx.textAlign = textAlign;
      ctx.textBaseline = textBaseline;
      ctx.lineWidth = lineWidth;
      ctx.strokeText(value, x, y);
      // highlights
      ctx.strokeStyle = highlightStyle;
      ctx.strokeText(value, x + offset, y);
    }
  });

  viewMockup(null, false);
};

const getPersonalizationCords = async function () {
  await solver.each.asyncTimeout(250);
  const adminTools = document.getElementById('admin-bar-iframe');
  if (!adminTools) return;

  const canvases = document.querySelectorAll('[data-el="product-properties"]');
  if (!canvases || (canvases && !canvases.length)) return;

  canvases.forEach((canvas) => {
    const ctx = canvas.getContext('2d');
    canvas.classList.remove('hidden');
    canvas.classList.add('edit');

    canvas.addEventListener('click', (event) => {
      if (personlizationTimeout) clearTimeout(personlizationTimeout);

      const rect = canvas.getBoundingClientRect();
      const { width, height, left, top } = rect;

      let x = event.clientX - left;
      x = (x / rect.width) * 100;
      x = parseFloat(x).toFixed(2);

      let y = event.clientY - top;
      y = (y / rect.height) * 100;
      y = parseFloat(y).toFixed(2);

      personlizationTimeout = setTimeout(() => {
        clearTimeout(personlizationTimeout);
        personlizationTimeout = null;

        info(`Copied! Left Position: ${x} / Top Position: ${y}`, {
          duration: 5000,
          dismissible: true,
          position: {
            x: solver.frontend.getCSSVariable('--notification-x-position'),
            y: solver.frontend.getCSSVariable('--notification-y-position')
          },
          types: [
            {
              type: 'info',
              icon: false
            }
          ]
        });

        navigator.clipboard.writeText(`${x} / ${y}`);
      }, 500);
    });
  });

  return canvases;
};

/*
 * Navigate to swiper and slide to personalization slide
 * @param { object } event - user driven event
 */

const viewMockup = async function (event, scroll = true) {
  if (event) event.preventDefault();

  const swiper = document.querySelector('[data-el="product-media"]');

  if (!swiper) return;

  const bounds = swiper.getBoundingClientRect();

  let index = null;
  state.swiper.slides.forEach((slide, i) => {
    const classList = [...slide.classList];

    if (
      index == null &&
      !classList.includes('swiper-slide-duplicate') &&
      classList.includes('swiper-slide--personalize')
    ) {
      index = i;
    }
  });

  if (index == null) return;

  state.swiper.slideToLoop(index, 500, null);

  if (scroll) window.scrollTo({ top: bounds.top, behavior: 'smooth' });
};

/*
 * Updates swiper and pagination
 * @param { object } event - user driven event
 * @param { string } color - value of color, leather, etc
 */
export const updateMediaUI = async function (event, color) {
  if (event) event.preventDefault();
  const container = document.querySelector('[data-el="media-container"]');
  const { media, product } = window.Solver;
  const { variant } = state;
  const product_media = window.Solver.product.media;
  let product_images = product_media.filter((item) => item.alt !== 'lifestyle');
  const lifestyle_images = product_media.filter((item) => item.alt == 'lifestyle');
  const swiper = state.swiper;
  const pagination = swiper.thumbs.swiper;
  const zoom_toggle_btn = document.querySelector('[data-el="zoom-toggle"]');

  if (variant) {
    const variant_index = product.variants.findIndex((v) => v.id == variant.id);
    let start_index = product.media.findIndex(
      (item) => variant.featured_media && item.id == variant.featured_media.id
    );
    let end_index = product.media.length;

    for (let i = variant_index; i < product.variants.length; i++) {
      const next_variant = product.variants[i];

      if (variant.option1 != next_variant.option1) {
        end_index = product.media.findIndex((item) => {
          if (item.id == next_variant?.featured_media?.id) {
            return item;
          }
        });

        if (end_index == -1) end_index = product.media.length;
        break;
      }
    }

    // Swap variable values if start > end
    if (start_index > end_index) end_index = [start_index, (start_index = end_index)][0];

    product_images = [];
    for (let i = start_index; i < end_index; i++) {
      const item = product_media[i];
      if (item && item.alt != 'lifestyle') product_images.push(item);
    }

    if (!product_images.length && product_media.length) product_images = product_media;
  }

  swiper.removeAllSlides();
  pagination.removeAllSlides();

  container.classList.add('fade');

  // Lifestyle Images
  lifestyle_images.forEach((image, index) => {
    const src = media[image.id];
    swiper.addSlide(
      index,
      new DOMParser().parseFromString(
        `
        <div class="swiper-slide lifestyle-image"
        >
          <div class="swiper-zoom-container">
            <img src="${src}" />
          </div>
        </div>
      `,
        'text/html'
      ).body.firstChild
    );

    pagination.addSlide(
      index,
      new DOMParser().parseFromString(
        `
        <div class="swiper-slide lifestyle-image"
        >
          <img src="${src}" />
        </div>
      `,
        'text/html'
      ).body.firstChild
    );
  });

  // Product /  Variant Images
  product_images.forEach((image, index) => {
    const src = media[image.id];
    let _variant = product.variants.find((v) => {
      if (v.featured_media && v.featured_media.id == image.id) {
        return v;
      }
    });

    if (variant) _variant = variant;

    if (image.alt == 'personalize') {
      swiper.addSlide(
        index,
        new DOMParser().parseFromString(
          `
          <div class="swiper-slide swiper-slide--personalize variant-image" data-variant="${_variant.id}" data-personalize="${image.id}">
            <div class="swiper-zoom-container">
              <img src="${src}" />
            </div>
          </div>
        `,
          'text/html'
        ).body.firstChild
      );
    } else {
      const markup = `
          <div class="swiper-slide variant-image">
            <div class="swiper-zoom-container">
              <img src="${src}" />
            </div>
          </div>
        `;

      swiper.addSlide(index, new DOMParser().parseFromString(markup, 'text/html').body.firstChild);
    }

    pagination.addSlide(
      index,
      new DOMParser().parseFromString(
        `<div class="swiper-slide variant-image">
          <img src="${src}" />
        </div>
      `,
        'text/html'
      ).body.firstChild
    );

    swiper.update();
  });

  swiper.slideToLoop(0, 500, null);

  await solver.frontend.asyncTimeout(500);

  container.classList.remove('fade');
};

/*
 * Sets dynamic colors to variant buttons
 */
export const setSwatchColor = function () {
  const variants = document.querySelectorAll('[data-color]:not([data-pagination])');

  if (!variants || (variants && !variants.length)) return;

  let names = [];
  let hex = [];

  variants.forEach((variant) => {
    let name = variant.getAttribute('data-color');

    // Match
    let match = window.Solver.colors[name];

    if (!match && name.indexOf('/') > -1) {
      const nameArr = name.split('/');
      match = window.Solver.colors[nameArr[0]];

      if (!match && nameArr.length > 1) {
        match = window.Solver.colors[nameArr[1]];
      }
    }

    if (!match) {
      variant.setAttribute('no-swatch-match', name);
    }

    variant.style.backgroundColor = match;
  });

  const cards = document.querySelectorAll('[data-product-card]');

  cards.forEach((card) => {
    const options = card.querySelectorAll('[data-color]');
    if (!options || (options && !options.length)) return;
    if (options.length <= 4) return;
    const diff = options.length - 4;

    const container = card.querySelector('.product__details-variants');

    container.innerHTML += `
        <button class="product__details-variant product__details-variant--additional-values" type="button">
          <span>+${options.length - 4}</span>
        </button>
      `;
  });
};

const setDisabledOption = function (option, value) {
  const product = window.Solver.product;
  const { available, variants, options } = product;
  const btns = document.querySelectorAll('.shopify-section.product [data-option-value]');

  const _displayNotifyBtn = (variant = state.variant) => {
    const notifyBtn = document.querySelector('[data-btn="notify-availability"]');
    if (!variant || !notifyBtn) return;

    notifyBtn.classList.remove('active');

    if (!window.Solver.phased_out) return;

    const phased_out = window.Solver.phased_out[variant.id];
    if (!phased_out && !variant.available) {
      notifyBtn.classList.add('active');
    }

    if (phased_out && phased_out !== 'T' && !variant.available) {
      notifyBtn.classList.add('active');
    }
  };

  const _displayUnavailableBtn = function (variant = state.variant) {
    const unavailableBtn = document.querySelector('[data-btn="out-of-stock"]');
    if (!variant || !unavailableBtn) return;

    unavailableBtn.classList.remove('active');

    if (!window.Solver.phased_out) return;

    const phased_out = window.Solver.phased_out[variant.id];

    if (phased_out && phased_out === 'T' && !variant.available) {
      unavailableBtn.classList.add('active');
    }
  };

  _displayUnavailableBtn();
  _displayNotifyBtn();

  // If product has multiple options
  if ((options.length > 1 && !option) || (options.length > 1 && !value)) return;

  if (options.length > 1 && option && value) {
    if (!swatchOptions.includes(option)) return;

    btns.forEach((btn) => {
      btn.classList.remove('product__details-variant--disabled');
      btn.classList.add('product__details-variant--hidden');
    });

    const listedOptions = [...variants]
      .filter((variant) => {
        let option1 = null;
        let option2 = null;
        let option3 = null;

        if (variant.option1) option1 = variant.option1;
        if (variant.option2) option2 = variant.option2;
        if (variant.option3) option3 = variant.option3;
        if (
          (option1 && option1 == value) ||
          (option2 && option2 == value) ||
          (option3 && option3 == value)
        ) {
          return variant;
        }
      })
      .map((variant) => variant.options)
      .flat(1)
      .forEach((option) => {
        let btn = document.querySelector(
          `.shopify-section.product [data-option-value="${option}"]`
        );
        if (!btn) {
          btn = document.querySelector(`.shopify-section.product [data-option-value="${option}"]`);
        }

        if (btn) btn.classList.remove('product__details-variant--hidden');
      });

    const unavailableOptions = [...variants]
      .filter((variant) => {
        let option1 = null;
        let option2 = null;
        let option3 = null;

        if (variant.option1) option1 = variant.option1;
        if (variant.option2) option2 = variant.option2;
        if (variant.option3) option3 = variant.option3;

        if (!variant.available) {
          if (
            (option1 && option1 == value) ||
            (option2 && option2 == value) ||
            (option3 && option3 == value)
          ) {
            return variant;
          }
        }
      })
      .map((variant) => variant.options)
      .flat(1);

    unavailableOptions.forEach((option) => {
      if (option == value) return;

      let btn = document.querySelector(`.shopify-section.product [data-option-value="${option}"]`);
      if (!btn) {
        btn = document.querySelector(`.shopify-section.product [data-option-value="${option}"]`);
      }

      if (btn) btn.classList.add('product__details-variant--disabled');
    });
    return;
  }

  // If product has single option
  btns.forEach((btn) => btn.classList.remove('product__details-variant--disabled'));

  variants.forEach((variant) => {
    if (!variant.available) {
      const option = variant.option1;
      const btn = document.querySelector(
        `.shopify-section.product [data-option-value="${option}"]`
      );
      if (btn) btn.classList.add('product__details-variant--disabled');
    }
  });
};

/*
 * Sets select option to state relates to variant
 * @param { object } event - user driven event
 * @param { string } option - option key. ex: color or size
 * @param { string } value - value of the option type. ex: blue or large
 */
const selectOption = async function (event, option, value) {
  if (event && event.clientX <= 0) return;
  if (!option || !value) return;

  let _option = option;
  if (option.indexOf('"') > -1) _option = handleize(option);

  const params = new URLSearchParams(document.location.search);
  let id = params.get('variant');
  state.setOption = {
    key: option,
    value
  };
  // Short delay to allow for state to update
  await solver.each.asyncTimeout(250);

  if (state.properties.Initials) {
    setPersonalizationProperties(
      {
        preventDefault: () => null,
        currentTarget: { value: state.properties.Initials }
      },
      'Initials'
    );
  }

  const labelText = handleize(option);
  const label = document.querySelector('[data-option-label="' + _option + '"]');
  if (label) {
    if (option && option.indexOf('"') > -1) {
      label.innerText = value + '"';
    } else {
      label.innerText = value;
    }
  }

  if (swatchOptions.includes(option)) updateMediaUI(null, value);

  await setPersonalizationUI();
  setProductPrice();
  setDisabledOption(option, value);
  setVariant(state.variant);

  if (!swatchOptions.includes(option) && state.variant && !id) {
    state.variant.options.forEach((value, index) => {
      if (swatchOptions.includes(window.Solver.product.options[index])) updateMediaUI(null, value);
    });
  }

  // Set the URL history to the new variant if exists
  if (state.variant && state.variant.id) {
    // Set url history
    history('variant', state.variant.id);
  }
};

/*
 * Set swiper image from thumbnail pagination
 * @param { object } event - user driven event
 * @param { string } variantId - the id of the variant to target in general
 */
const selectThumbnail = async function (event, variantId) {
  const target = event.currentTarget;
  const params = new URLSearchParams(document.location.search);
  let id = params.get('variant');

  // Use found variant in thumbnail
  let variant = [...window.Solver.product.variants].find((v) => v.id == variantId);
  if (!variant) return;

  // If more related variants use first index
  const relatedVariants = [...window.Solver.product.variants].filter((v) => {
    if (v.available && v.option1 == variant.option1) return v;
  });

  const thumbnailIndex = target.getAttribute('data-pagination');
  const swatchValue = target.getAttribute('data-color');

  let relatedThumbnails = document.querySelectorAll(
    `[data-pagination][data-color="${swatchValue}"]`
  );

  if (!swatchValue) {
    relatedThumbnails = document.querySelectorAll(`[data-pagination]`);
  }

  if (!relatedThumbnails || (relatedThumbnails && !relatedThumbnails.length)) return;

  let index = 0;
  relatedThumbnails.forEach((thumbnail, _index) => {
    if (thumbnail.getAttribute('data-pagination') == thumbnailIndex) index = _index;
  });

  if (!id) {
    if (relatedVariants && relatedVariants.length) {
      variant = relatedVariants[0];
    }

    // call selectOption to set the variant
    let index = 0;
    const _selectOption = async function () {
      await selectOption(null, window.Solver.product.options[index], variant.options[index]);

      if (index >= variant.options.length - 1) return;
      index++;

      await _selectOption();
    };

    await _selectOption();
  }

  state.swiper.slideToLoop(index, 500, null);
};

/*
 * Listens for event on the add to cart button. Adds if variant combo is valid
 */
const addToCart = async function () {
  const btn = document.querySelector('[data-btn="add-to-cart"]');

  if (!btn) return;

  btn.addEventListener('click', async (event) => {
    if (!state.variant) {
      info(TYPES.CART.NO_VARIANT_SELECTED);
      return;
    }

    if (!state.variant.available) {
      info(state.variant.options.join(', ') + ' is currently not available');
      return;
    }

    let properties = state.properties;

    if (window.Solver.product.options.includes('Denominations')) {
      const recipients = state.recipients.filter((recipient) => {
        if (recipient.email && validation.email(recipient.email)) return recipient;
        if (recipient.email && !validation.email(recipient.email)) {
          info(recipient.email + ' is not a valid email address');
        }
      });

      if (recipients && recipients.length > 0) {
        await solver.each.asyncTimeout(1000);

        const fromInput = document.querySelector('[data-el="recipient-from"]');
        let From = '';
        let index = 0;

        if (fromInput && fromInput.value) From = fromInput.value;

        const _addToCart = async function () {
          const recipient = recipients[index];

          properties = {
            'To': recipient.email,
            From,
            'Message': recipient.message
          };

          const req = await add(event, state.variant.id, 1, properties);

          if (!req.data) {
            error(TYPES.GENERIC);
            return;
          }

          index = index + 1;

          if (index >= recipients.length) {
            await open();
            await get();
            success(TYPES.CART.UPDATED);
            return;
          }

          _addToCart();
        };

        _addToCart();
      } else {
        const req = await add(event, state.variant.id, 1, properties);

        if (!req.data) {
          error(TYPES.GENERIC);
          return;
        }

        await open();
        await get();
        success(TYPES.CART.UPDATED);
      }

      return;
    }

    if (window.Solver.collection && window.Solver.collection.template_suffix == 'sale') {
      properties._LPROP = 'Final Sale';
    }

    const req = await add(event, state.variant.id, 1, properties);

    if (!req.data) {
      error(TYPES.GENERIC);
      return;
    }

    await open();
    await get();
    success(TYPES.CART.UPDATED);
  });
};

/**
 * Generates the markup for each recommendation retrived from product-recommendation template
 */
const getRecommendations = async function () {
  if (!window.Solver.product) return;

  const res = await shopify.product.recommendations(window.Solver.product.id);

  if (!res || (res && !res.data)) return;

  const html = document.createElement('div');
  html.innerHTML = res.data;

  const container = document.querySelector('.product-recommendations__items');
  const recommendations = html.querySelector('.product-recommendations__items');

  if (recommendations && recommendations.innerHTML.trim().length) {
    container.innerHTML = recommendations.innerHTML;
  }

  setSwatchColor();
};

/**
 * Set the variant image on a product card
 * @param { object } event - user generated event
 * @param { string } id - unique id so that proudcts with similar ids do not collide, unique to the product card
 * @param { string } variantID - unique variant id for updating url
 * @param { string } imgSrc - the source of the image to be updated
 * @param { string } title - title for updated alt tag
 */
const setProductCardVariant = async function (event, id, variantID, imgSrc, title) {
  if (!event || !id || !imgSrc) return;

  const target = event.currentTarget;
  const btns = document.querySelectorAll(`[data-product-card="${id}"] [data-product-card-option]`);
  const anchor = document.querySelector(
    `[data-product-card="${id}"] [data-el="product-card-image"]`
  );

  btns.forEach((btn) => btn.classList.remove('product__details-variant--active'));
  target.classList.add('product__details-variant--active');

  if (anchor && variantID) {
    let href = new URL(anchor.href);
    href.searchParams.set('variant', variantID);
    anchor.href = href;
    if (title) anchor.title = title;
  }

  const imgs = document.querySelectorAll(`[data-product-card-image="${id}"]`);
  imgs.forEach((img) => {
    img.src = imgSrc;
    if (title) img.alt = title;
  });
};

/**
 * Set variant selection if params are available or choose first available
 */
const setVariant = async function (_variant = null) {
  const params = new URLSearchParams(document.location.search);
  let id = params.get('variant');
  let variant = _variant;
  let option = null;

  // get variant from URL
  if (!variant && id) {
    variant = window.Solver.product.variants.find((v) => v.id == id);
  }

  // else get variant from state
  if (!variant && !id && state.variant) {
    variant = state.variant;
  }

  // else get first available variant from product
  if (!variant) {
    variant = [...window.Solver.product.variants].find((v) => {
      if (v.price >= v.compare_at_price && v.available) return v;
    });

    // if from sale collection
    if (window.Solver.collection && window.Solver.collection.template_suffix == 'sale') {
      variant = [...window.Solver.product.variants].find((v) => {
        if (v.price < v.compare_at_price && v.available) return v;
      });
    }
  }

  // else get first variant from product even if unavailable
  if (!variant) {
    variant = window.Solver.product.variants[0];
  }

  const btns = document.querySelectorAll(`button[data-option-value]`);
  if (btns && btns.length) {
    btns.forEach((btn) => btn.classList.remove('product__details-variant--active'));
  }

  variant.options.forEach((option, index) => {
    let _option = option;
    if (option && option.indexOf('"') > -1) _option = handleize(option);

    const labelText = handleize(window.Solver.product.options[index]);
    const label = document.querySelector('[data-option-label="' + labelText + '"]');
    const btn = document.querySelector(`button[data-option-value="${_option}"]`);

    if (btn && label) {
      btn.classList.add('product__details-variant--active');
      const text = btn.getAttribute('data-option-label');
      if (option && option.indexOf('"') > -1) {
        label.innerText = text + '"';
      } else {
        label.innerText = text;
      }
    }
  });

  if (!state.variant) {
    variant.options.forEach((value, index) => {
      state.setOption = {
        key: window.Solver.product.options[index],
        value
      };
    });
  }
};

/**
 * Sets new swiper for product media
 */
export const setProductMedia = function () {
  const pagination = new Swiper(`[data-el="product-pagination"]`, {
    direction: 'vertical',
    spaceBetween: 0,
    slidesPerView: 'auto',
    watchSlidesProgress: true
  });

  const swiper = new Swiper(`[data-el="product-media"]`, {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    effect: 'fade',
    zoom: {
      minRatio: 1,
      maxRatio: 3,
      toggle: true,
      zoomedSlideClass: 'swiper-zoom-container'
    },
    thumbs: {
      swiper: pagination
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    scrollbar: {
      el: '.product__swiper-scrollbar'
    },
    on: {
      click: function () {
        swiper.zoom.toggle(swiper.clickedSlide);
      }
    }
  });

  state.setSwiper = swiper;
};

/**
 * Sets desktop pagination max-height dynamic to hero image height
 */
export const setPaginationMaxHeight = function () {
  const pagination = document.querySelector('[data-el="product-pagination"]');
  const swiper = document.querySelector('[data-el="product-media"] .swiper-zoom-container');

  if (!swiper) return;

  const swiperHeight = swiper.getBoundingClientRect().height;

  pagination.style.maxHeight = swiperHeight + 'px';
};

/**
 * Sets product price depending on current variant
 */
const setProductPrice = function () {
  if (!state.variant) return;

  const _product = window.Solver.product;
  const priceEl = document.querySelector('[data-price]');
  const compareAtEl = document.querySelector('[data-compare-at]');

  if (!compareAtEl) {
    let price = null;

    price = currency(_product.price, { fromCents: true }).format();

    if (_product.variants.length > 0 && state.variant) {
      price = currency(state.variant.price, { fromCents: true }).format();
    }

    priceEl.innerText = price;
    return;
  }

  compareAtEl.innerText = '';

  if (_product.variants.length > 0 && state.variant) {
    const price = currency(state.variant.price, { fromCents: true }).format();
    const compare_at_price = currency(window.Solver.product.compare_at_price, {
      fromCents: true
    }).format();

    if (state.variant.compare_at_price && state.variant.price < state.variant.compare_at_price) {
      priceEl.classList.add('product__details-price--sale');
      priceEl.innerText = price;
      compareAtEl.innerText = compare_at_price;
    } else {
      priceEl.classList.remove('product__details-price--sale');
      priceEl.innerText = price;
      compare_at_price.innerText == '';
    }
  } else {
    const price = currency(_product.price, { fromCents: true }).format();
    const compare_at_price = currency(_product.compare_at_price, {
      fromCents: true
    }).format();

    if (_product.compare_at_price && _product.price < _product.compare_at_price) {
      priceEl.classList.add('product__details-price--sale');
      priceEl.innerText = price;
      compareAtEl.innerText = compare_at_price;
    } else {
      priceEl.classList.remove('product__details-price--sale');
      priceEl.innerText = price;
      compareAtEl.innerText = '';
    }
  }
};

/**
 * Adds recipient for gift cards
 * @param { object } event - user generated event
 * @param { string } key - field of recipient to be updated
 * @param { string|number } id - unique recipent id
 */
const setRecipient = function (event, key, id) {
  event.preventDefault();

  const value = event.currentTarget.value;

  const recipients = state.recipients;

  recipients.forEach((recipient) => {
    if (id == recipient.id) {
      recipient[key] = value;
    }
  });

  state.setRecipients = recipients;
};

/**
 * Adds recipient for gift cards
 * @param { object } event - user generated event
 */
const addRecipient = async function (event) {
  if (event) event.preventDefault();

  const id = new Date().getTime();

  state.addRecipient = {
    id,
    email: '',
    message: ''
  };

  const container = document.querySelector('[data-el="recipients"]');

  if (!container) return;

  const req = await fetch('/?sections=recipient');

  if (req.error) {
    error(req.error.message ? req.error.message : req.error);
    return;
  }

  let markup = await req.json();
  markup = markup.recipient;

  const parser = new DOMParser();
  markup = parser.parseFromString(markup, 'text/html');
  markup = markup.querySelector('.form__input');

  markup.setAttribute('data-recipient', id);
  markup
    .querySelector('input')
    .addEventListener('keyup', (event) => setRecipient(event, 'email', id));
  markup
    .querySelector('textarea')
    .addEventListener('keyup', (event) => setRecipient(event, 'message', id));
  markup.querySelector('.button--primary').addEventListener('click', (event) => addRecipient);
  markup
    .querySelector('.button--red')
    .addEventListener('click', (event) => removeRecipient(event, id));

  container.append(markup);
};

const setRecipientForm = function (event) {
  if (event) event.preventDefault();

  const form = document.querySelector('[ data-el="recipients"]');

  if (!form) return;

  form.classList.toggle('product-recipient--active');

  if (form && form.className.indexOf('product-recipient--active') == -1) {
    state.setRecipients = [
      {
        id: 1,
        email: '',
        message: ''
      }
    ];

    const fromInput = document.querySelector('[data-el="recipient-from"]');
    fromInput.value = '';

    const fields = document.querySelectorAll('[data-recipient]');
    fields.forEach((field) => {
      const id = field.getAttribute('data-recipient');

      if (id == '1') {
        field.querySelector('input').value = '';
        field.querySelector('textarea').value = '';
      } else {
        field.remove();
      }
    });
  }
};

const setNotifyModal = async function () {
  if (!window.klaviyo || (window.klaviyo && !window.Solver.klaviyo_public_token)) {
    return;
  }

  const button_background_color = solver.frontend.getCSSVariable(
    '--button-primary-background-color'
  );
  const button_text_color = solver.frontend.getCSSVariable('--button-primary-text-color');
  const { id, title } = window.Solver.product;

  const {
    klaviyo_public_token,
    klaviyo_notify_text,
    klaviyo_notify_label_text,
    klaviyo_notify_button_text,
    klaviyo_notify_success_text
  } = window.Solver;

  klaviyo.init({
    account: klaviyo_public_token,
    platform: 'shopify'
  });

  klaviyo.enable('backinstock', {
    trigger: {
      product_page_class: 'button button__klaviyo-notify button--primary',
      product_page_margin: '0px',
      product_page_text: 'Notify When Available',
      product_page_text_align: 'center',
      replace_anchor: false
    },
    modal: {
      additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
      background_color: '#fff',
      body_content: klaviyo_notify_text,
      button_background_color,
      button_label: klaviyo_notify_button_text,
      button_text_color,
      close_button_color: '#ccc',
      drop_background_color: '#000',
      email_field_label: klaviyo_notify_label_text,
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      footer_content: '',
      headline: title,
      subscription_success_label: klaviyo_notify_success_text,
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500',
      text_color: '#222'
    }
  });
};

/**
 * Removes "Zoom" button after clicking swiper container
 */
const zoomLabel = function () {
  const container = document.querySelector('[data-el="media-container"]');
  const btn = document.querySelector('[data-el="zoom"]');

  container.addEventListener('click', (event) => btn.remove());

  setTimeout(() => {
    if (btn) btn.remove();
  }, 3000);
};

/**
 *
 * Opens first Product details accordion
 */

const openFirstDrawer = function () {
  const accordion = document.querySelector('.product__details-accordion');
  const first_drawer = accordion.querySelector('.accordion__title');
  if (!accordion) return;

  first_drawer.click();
};

const setRatingScrollTo = function (event) {
  if (event) event.preventDefault();

  const reviews = document.getElementById('judgeme_product_reviews');
  if (!reviews) return;

  const { top } = reviews.getBoundingClientRect();
  window.scrollTo({ top, behavior: 'smooth' });
};

export const product = async function () {
  const params = new URLSearchParams(document.location.search);
  let id = params.get('variant');

  window.Solver.addRecipient = addRecipient;
  window.Solver.setPersonalizationProperties = setPersonalizationProperties;
  window.Solver.setProductCardVariant = setProductCardVariant;
  window.Solver.setRecipient = setRecipient;
  window.Solver.setRecipientForm = setRecipientForm;
  window.Solver.viewMockup = viewMockup;

  if (!window.Solver.product) return;

  window.Solver.selectOption = selectOption;
  window.Solver.selectThumbnail = selectThumbnail;
  window.Solver.setRatingScrollTo = setRatingScrollTo;

  const type = handleize(window.Solver.product.type);
  if (type == 'boot' || type == 'boots') {
    window.Solver.product = sanitizeProductOptions(window.Solver.product);
  }

  // Immediate UI
  setProductMedia();
  setPaginationMaxHeight();
  setVariant();
  setProductPrice();
  setSwatchColor();
  setPersonalizationUI();
  await getPersonalizationCords();

  // Delayed UI
  addToCart();
  setNotifyModal();
  zoomLabel();

  if (state.variant) {
    const product = window.Solver.product;
    const { available, variants, options } = product;
    let index = [...options].findIndex((o) => swatchOptions.includes(o));
    const option = options[index];

    if (index >= 0) index = index + 1;
    const value = state.variant['option' + index];

    if (id) {
      updateMediaUI(null, value);
    }

    if (option && value) {
      setDisabledOption(option, value);
    } else {
      setDisabledOption();
    }
  } else {
    setDisabledOption();
  }

  await getRecommendations();
};
